const SingleNewsView = Barba.BaseView.extend({
    namespace: 'single-news',

    onEnter() {
        new MainMenu(this.container);
        new InViewAnimation();
        new SearchModal(this.container);

        setIframeAspectRatios(this.container);
        initSlideshows(this.container);

        this.init360Pano();
    },

    init360Pano() {
        const panoTrigger = this.container.querySelector('.jsProject360Btn');

        if (panoTrigger !== null) {
            panoTrigger.addEventListener('click', _ => {
                // Create a panorama wrapper
                const uniqid = Math.random() * 16;
                this.panoWrapper = document.createElement('div');

                this.panoWrapper.classList.add('pano-wrapper');
                this.panoWrapper.id = 'pano-wrapper-' + uniqid;

                const closeBtn = document.createElement('button');
                closeBtn.type = 'button';
                closeBtn.classList.add('pano-wrapper__close-btn');
                this.panoWrapper.appendChild(closeBtn);

                // Add a close event listener
                closeBtn.addEventListener('click', _ => this.closePano());

                // Add to the body
                this.panoWrapper.style.opacity = 0;
                document.body.appendChild(this.panoWrapper);

                // Init the viewer
                this.pannellumView = pannellum.viewer('pano-wrapper-' + uniqid, {
                    'type': 'equirectangular',
                    'panorama': panoTrigger.dataset.panoUrl,
                    'autoLoad': true
                });

                // Show the panorama
                TweenLite.to(this.panoWrapper, 0.5, { opacity: 1, ease: Power2.easeInOut });
            });
        }
    },

    closePano() {
        TweenLite.to(this.panoWrapper, 0.5, {
            opacity: 0, ease: Power2.easeInOut, onComplete: _ => {
                this.pannellumView.destroy();
                this.panoWrapper.parentElement.removeChild(this.panoWrapper);
            }
        });
    }
});

SingleNewsView.init();